/* Visiloox newsletter popup router.
   Picks one of two Klaviyo forms (Frau / Mann): ad link > product or page (set by Liquid) > stable random.
   Opens it after 8 s AND 30 % scroll, or on desktop exit intent.
   Both Klaviyo forms must be set to "Only show on custom trigger": this file owns timing and frequency,
   because a custom trigger overrides Klaviyo's own targeting. */
(function (root) {
  // ponytail: Klaviyo reports per form, not per route (ad/product/page/random). Split the random group
  // into its own two forms if a clean image comparison is needed later.
  var FORMS = { frau: 'THaJrr', mann: 'V99AGU' }; // IDs of the two Klaviyo forms
  var PAUSE_DAYS = 14;
  var DELAY_MS = 8000;
  var SCROLL_SHARE = 0.3;
  var SKIP_PATH = /^\/(cart|account|policies|pages\/(datenschutz|impressum|widerruf|sehwerte))/;

  function valid(seg) {
    return seg === 'frau' || seg === 'mann';
  }

  function pickSegment(ad, page, random) {
    if (valid(ad)) return ad;
    if (valid(page)) return page;
    return random;
  }

  function isPaused(done, closedAt, now) {
    if (done) return true;
    return now - (Number(closedAt) || 0) < PAUSE_DAYS * 864e5;
  }

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { pickSegment: pickSegment, isPaused: isPaused };
    return;
  }

  function store(name) {
    return {
      get: function (k) { try { return root[name].getItem(k); } catch (e) { return null; } },
      set: function (k, v) { try { root[name].setItem(k, v); } catch (e) {} }
    };
  }
  var local = store('localStorage');
  var session = store('sessionStorage');
  var script = document.currentScript;

  // Remember close/submit for both forms together, including opens via the Klaviyo teaser.
  root.addEventListener('klaviyoForms', function (e) {
    var d = e.detail || {};
    if (d.formId !== FORMS.frau && d.formId !== FORMS.mann) return;
    // The home sticky CTA sits above Klaviyo (z-index 99999 vs 90000); hide it while our popup is open.
    if (d.type === 'open') document.documentElement.classList.add('vlx-popup-open');
    if (d.type === 'submit') local.set('vlx_pop_done', '1');
    if (d.type === 'close') {
      local.set('vlx_pop_closed', String(Date.now()));
      document.documentElement.classList.remove('vlx-popup-open');
    }
  });

  if (SKIP_PATH.test(location.pathname)) return;
  if (isPaused(local.get('vlx_pop_done'), local.get('vlx_pop_closed'), Date.now())) return;

  var ad = new URLSearchParams(location.search).get('vx_seg');
  if (valid(ad)) session.set('vlx_pop_seg_ad', ad);
  var random = local.get('vlx_pop_seg_rand');
  if (!valid(random)) {
    random = Math.random() < 0.5 ? 'frau' : 'mann';
    local.set('vlx_pop_seg_rand', random);
  }
  var seg = pickSegment(session.get('vlx_pop_seg_ad'), script && script.dataset.pageSeg, random);

  var opened = false;
  var waited = false;
  var scrolled = false;

  function scrollShare() {
    var max = document.documentElement.scrollHeight - root.innerHeight;
    return max <= 0 ? 1 : root.scrollY / max;
  }

  function tryOpen(exitIntent) {
    // Never interrupt the Sehwerte drawer; the next scroll after closing it tries again.
    if (opened || document.body.classList.contains('vlx-prescription-drawer-open')) return;
    if (!exitIntent && !(waited && scrolled)) return;
    opened = true;
    Promise.resolve(root.klaviyo && root.klaviyo.isIdentified ? root.klaviyo.isIdentified() : false)
      .catch(function () { return false; })
      .then(function (known) {
        if (known) return;
        root._klOnsite = root._klOnsite || [];
        root._klOnsite.push(['openForm', FORMS[seg]]);
      });
  }

  setTimeout(function () { waited = true; tryOpen(false); }, DELAY_MS);
  root.addEventListener('scroll', function () {
    if (scrollShare() >= SCROLL_SHARE) scrolled = true;
    tryOpen(false);
  }, { passive: true });
  if (root.matchMedia('(hover: hover) and (pointer: fine)').matches) {
    document.addEventListener('mouseout', function (e) {
      if (!e.relatedTarget && e.clientY <= 0) tryOpen(true);
    });
  }
})(typeof window !== 'undefined' ? window : this);
